<template>
    <div class="context-bar">
        <i class="fad fa-fw bar-icon" :class="icon"></i>
        <nav class="crumbs" aria-label="Breadcrumb">
            <template v-for="(crumb, index) in crumbs">
                <i class="fas fa-chevron-right crumb-sep" v-if="index > 0" :key="'sep' + index"></i>
                <router-link v-if="crumb.to && index < crumbs.length - 1" :to="crumb.to" class="crumb" :key="'c' + index">{{ crumb.label }}</router-link>
                <span v-else class="crumb current" :key="'c' + index">
                    {{ crumb.label }}<span class="crumb-sub" v-if="crumb.sub">{{ crumb.sub }}</span>
                </span>
            </template>
        </nav>
        <div class="bar-actions">
            <slot></slot>
            <b-button v-if="close" tag="router-link" :to="closeRoute" type="is-primary" outlined size="is-small">
                <i class="fas mr-2" :class="closeIcon"></i>{{ close }}
            </b-button>
        </div>
    </div>
</template>

<script>
    // Breadcrumb bar under the top nav for drill-downs (a course enrollment,
    // a conference registration, a catalog audience/category). `crumbs` is
    // [{label, to?, sub?}]; the last crumb is the current location and is
    // never linked. An optional close button offers the way out.
    export default {
        name: "ContextBar",
        props: {
            crumbs: {type: Array, default: () => []},
            icon: {default: 'fa-chalkboard-teacher'},
            close: {},
            closeIcon: {default: 'fa-times'},
            closeRoute: {default: () => ({name: 'dashboard'})}
        }
    };
</script>

<style lang="scss" scoped>
    $nav-blue: #336699;
    $nav-text: #4a4a4a;

    .context-bar {
        position: relative;
        z-index: 105;
        display: flex;
        align-items: center;
        min-height: 50px;
        padding: 0.4rem 1.25rem 0.4rem 1.5rem;
        background: #f7f8fa;
        color: $nav-text;
        border-bottom: 1px solid #dfe2e8;

        @media (max-width: 768px) {
            padding: 0.4rem 0.75rem 0.4rem 1rem;
        }
    }

    .bar-icon {
        font-size: 1.3rem;
        margin-right: 0.8rem;
        color: #3c6691;
        flex: none;

        @media (max-width: 768px) {
            display: none;
        }
    }

    .crumbs {
        flex: 1;
        min-width: 0;
        display: flex;
        align-items: center;
        white-space: nowrap;
        overflow: hidden;
        font-size: 0.95rem;
    }

    .crumb {
        color: $nav-blue;
        font-weight: 500;
        text-overflow: ellipsis;
        overflow: hidden;

        &:hover {
            text-decoration: underline;
        }

        &.current {
            color: $nav-text;
            font-weight: 700;
        }
    }

    .crumb-sep {
        font-size: 0.6rem;
        margin: 0 0.6rem;
        color: #9aa3b0;
        flex: none;
    }

    .crumb-sub {
        margin-left: 0.6rem;
        font-size: 0.85rem;
        font-weight: normal;
        color: #666d7a;
    }

    .bar-actions {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        margin-left: 1rem;
        flex: none;
    }
</style>
